// NOTE: this file is intentionally duplicated (verbatim) at
// ar-viewer/src/sliderThrottle.js — the AR viewer is a separate npm package
// and cannot import editor code. Keep both copies in sync; if you change the
// logic here, port the change over there too (and vice versa).
//
// Coalesce high-frequency slider updates: leading-edge flush, single trailing
// flush per interval, per-name dedupe against the last flushed value.
export function createSliderThrottle({ intervalMs = 100, flush }) {
  let timer = null;
  let pending = null; // { [name]: value } accumulated during a window
  const lastFlushed = {}; // { [name]: value }

  function doFlush(patch) {
    const out = {};
    let has = false;
    Object.keys(patch).forEach((name) => {
      if (lastFlushed[name] !== patch[name]) {
        out[name] = patch[name];
        lastFlushed[name] = patch[name];
        has = true;
      }
    });
    if (has) flush(out);
  }

  function openWindow() {
    timer = setTimeout(() => {
      timer = null;
      const p = pending;
      pending = null;
      if (p) doFlush(p);
    }, intervalMs);
  }

  return {
    push(name, value) {
      if (timer === null) {
        doFlush({ [name]: value }); // leading edge
        openWindow();
      } else {
        pending = pending || {};
        pending[name] = value; // trailing accumulates
      }
    },
    cancel() {
      if (timer) clearTimeout(timer);
      timer = null;
      pending = null;
    }
  };
}
